import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { CELL_SETTINGS } from './constants';

export const ListWrapper = styled.div`
  .ReactVirtualized__Grid:focus {
    outline: none;
  }

  div,
  p,
  a {
    &[data-text-type='main-text'] {
      font-size: 14px;
      line-height: 24px;
      font-weight: 400;
      color: var(--rhino);
    }

    &[data-text-type='sub-text'] {
      font-size: 12px;
      line-height: 20px;
      font-weight: 400;
      color: var(--lynch);
      margin-top: 2px;
    }

    &[data-text-type='highlighted-text'] {
      font-weight: 600;
      font-size: 14px;
      line-height: 24px;
      color: var(--all-ports);
    }
  }

  div,
  a {
    &[data-type='icon'] {
      width: 40px;
      height: 40px;
      border-radius: 100%;

      &:hover {
        background: var(--wash-me);
      }
    }
  }

  .tooltip-wrapper {
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const AbsoluteBorder = styled.div`
  display: none;
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 1px;
  box-shadow:
    0 4px 8px -2px rgba(12, 16, 33, 0.1),
    0 2px 4px -2px rgba(12, 16, 33, 0.06);
  background-color: var(--border1);
`;

const Cell = styled.div`
  &[${CELL_SETTINGS.lastColumnDataAttribute}='true'] {
    position: relative;

    &.${CELL_SETTINGS.hasBorderClassName} ${AbsoluteBorder} {
      display: block;
    }
  }
`;

export const HeaderCell = styled(Cell)<{
  columnIndexType: 'first' | 'last' | null;
}>`
  border-top: 1px solid var(--border1);
  border-bottom: 1px solid var(--border1);
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: var(--neut2);
  background: var(--tbheader);

  ${props =>
    props.columnIndexType === 'first' &&
    css`
      border-left: 1px solid var(--border1);
      border-top-left-radius: 4px;
    `}

  ${props =>
    props.columnIndexType === 'last' &&
    css`
      border-right: 1px solid var(--border1);
      border-top-right-radius: 4px;
    `}

  &:hover {
    background-color: var(--white);
  }
`;

export const BodyCell = styled(Cell)<{
  rowIndexType: 'first' | 'last' | null;
  columnIndexType: 'first' | 'last' | null;
  paddingLayer: 'self' | 'first_child';
}>`
  border-bottom: 1px solid var(--border1);

  ${props =>
    props.columnIndexType === 'first' &&
    css`
      border-left: 1px solid var(--border1);
    `}

  ${props =>
    props.columnIndexType === 'last' &&
    css`
      border-right: 1px solid var(--border1);
    `}

  ${props =>
    props.paddingLayer === 'first_child'
      ? css`
          > * {
            padding: 16px ${CELL_SETTINGS.horizontalPadding}px;
          }
        `
      : css`
          padding: 16px ${CELL_SETTINGS.horizontalPadding}px;
        `}

  ${props =>
    props.rowIndexType === 'last' &&
    props.columnIndexType === 'first' &&
    css`
      border-bottom-left-radius: 4px;
    `};

  ${props =>
    props.rowIndexType === 'last' &&
    props.columnIndexType === 'last' &&
    css`
      border-bottom-right-radius: 4px;
    `};
`;

export const HeaderWrapper = styled.div<{ isActive: boolean }>`
  padding: 12px ${CELL_SETTINGS.horizontalPadding}px;
  background-color: ${props => (props.isActive ? 'var(--white)' : 'var(--wash-me)')};

  &:hover {
    /* background-color: var(--white); */
  }
`;

export const HeaderIconWrapper = styled.div<{ isActive?: boolean }>`
  height: 28px;
  width: 28px;
  border-radius: 50%;
  ${props =>
    props.isActive &&
    css`
      background-color: var(--wash-me);
      box-shadow:
        0 1px 2px rgba(12, 16, 33, 0.05),
        0 0 0 4px var(--border1);
    `}

  &:hover {
    background-color: var(--wash-me);
  }
`;

export const HeaderAllOptions = styled.div`
  max-height: 320px;
  box-shadow: 0 32px 64px -12px rgba(12, 16, 33, 0.14);
  border: 1px solid var(--border1);
  border-radius: 4px;
  background-color: var(--white);
`;

export const HeaderEachOption = styled.p`
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: var(--rhino);
  padding: 16px;
  border-radius: inherit;

  &:hover {
    background-color: var(--wash-me);
  }
`;
